import React from 'react';
import './HowItWorks.css';
// import logo from '../logos/Logo-hw-tran.png';
// import ContactForm from '../components/ContactForm';

const HowItWorks = () => {
  return (
    <div className="hiw-container">
      {/* Background Section */}
      {/* <div className="hiw-background">
        <div className="hiw-text-container">
          <img src={logo} alt="Top Tier Benefits Logo" className="hiw-logo" />
          <h1 className="hiw-header">
            It only takes a few minutes for you to experience the way pharmacy is supposed to be.
          </h1>
          <a href="/contact" className="hiw-contact-button">
            Contact Us &rarr;
          </a>
        </div>


        <div className="contact-card">
          <ContactForm />
        </div>
      </div> */}

      {/* How It Works Section */}
      <div className="how-it-works-container">
        <h2 className="how-it-works-title">How It Works</h2>

        {/* Step 1 */}
        <div className="how-it-works-section">
          <div className="how-it-works-left">
            <div className="step-number">1</div>
            <h3 className="step-title">Built For Our Clients And Their Employees</h3>
            <p className="step-description">
              Top Tier Benefits has established a strong network and a robust IT infrastructure for efficient intake and processing.
            </p>
            <p className="step-description">
              Our comprehensive IT development ensures primary and secondary routing to cost-effective options.
            </p>
          </div>
          <div className="how-it-works-right">
            <img
              src={require('../logos/clients.jpg')}
              alt="Teamwork"
              className="step-image"
            />
          </div>
        </div>

        {/* Step 2 */}
        <div className="how-it-works-section reverse">
          <div className="how-it-works-left">
            <img
              src={require('../logos/network.jpg')}
              alt="Network"
              className="step-image"
            />
          </div>
          <div className="how-it-works-right">
            <div className="step-number">2</div>
            <h3 className="step-title">Streamlined Network</h3>
            <p className="step-description">
              Our network focuses on safety and efficacy first.  
            </p>
            <p className="step-description">
              Our rigorous controls ensure world-class protection and quality. 
            </p>
          </div>
        </div>

        {/* Step 3 */}
        <div className="how-it-works-section">
          <div className="how-it-works-left">
            <div className="step-number">3</div>
            <h3 className="step-title">Simple Process</h3>
            <p className="step-description">
              Our ordering process for clients and members is easy, convenient, fast, trustworthy, and secure.            
            </p>
            <p className="step-description">
              Members can submit documents, check progress, and track shipments through our web portal. 
            </p>
          </div>
          <div className="how-it-works-right">
            <img
              src={require('../logos/delivery.jpg')}
              alt="Home Delivery"
              className="step-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
